import { FC, useState } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { SearchModal } from '../../features/search/SearchModal.client';
import { Responsive } from '../Responsive.client';
import { SafeParallax } from '../SafeParallax.client';
import { DesktopHeader } from './DesktopHeader.client';
import { FixedHeader } from './FixedHeader.client';
import { MobileHeader } from './MobileHeader.client';

interface Props {
  isLogin: boolean;
}

export const Header: FC<Props> = (props) => {
  const [openSearch, setOpenSearch] = useState(false);
  const [showFixedHeader, setShowFixedHeader] = useState(false);

  return (
    <>
      <header className="absolute top-0 z-50 w-full">
        <ParallaxProvider>
          <SafeParallax
            onEnter={() => setShowFixedHeader(false)}
            onExit={() => setShowFixedHeader(true)}
            fallback={
              <Responsive
                desktop={DesktopHeader}
                mobile={MobileHeader}
                props={{
                  isLogin: props.isLogin,
                  onClickSearch: () => setOpenSearch(true),
                }}
                className="z-[1] w-full bg-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)] md:relative md:z-50"
              />
            }
          >
            <Responsive
              desktop={DesktopHeader}
              mobile={MobileHeader}
              props={{
                isLogin: props.isLogin,
                onClickSearch: () => setOpenSearch(true),
              }}
              className="z-[1] w-full bg-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)] md:relative md:z-50"
            />
          </SafeParallax>
        </ParallaxProvider>
      </header>
      <FixedHeader
        show={showFixedHeader}
        isLogin={props.isLogin}
        onClickSearch={() => setOpenSearch(true)}
      />
      <SearchModal open={openSearch} onClose={() => setOpenSearch(false)} />
    </>
  );
};
